var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container_ekmtc" },
    [_c("router-view"), _c("Quick")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }